class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibilityHeader();
    this.setHeaderCartIconAccessibilityFooter();
  }

  //更新
  setHeaderCartIconAccessibilityHeader() {
    const cartLinkHeader = document.querySelector('#cart-icon-bubble');
    cartLinkHeader.setAttribute('role', 'button');
    cartLinkHeader.setAttribute('aria-haspopup', 'dialog');
    cartLinkHeader.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLinkHeader);
    });
    cartLinkHeader.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLinkHeader);
      }
    });
  }

  //更新
  setHeaderCartIconAccessibilityFooter() {
    const cartLinkFooter = document.querySelector('#cart-icon-bubble02');
    cartLinkFooter.setAttribute('role', 'button');
    cartLinkFooter.setAttribute('aria-haspopup', 'dialog');
    cartLinkFooter.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLinkFooter)
    });
    cartLinkFooter.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLinkFooter);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    //更新
    if (triggeredBy) {
        setTimeout(() => {this.classList.add('animate', 'active')});
    }
    
    //更新
    let target = document.querySelectorAll('.header-rinner__item.cart');;
    setTimeout(() => {
      for(let i in target){
        target[i].classList.add('anim'); 
      }
    }, 0);
    setTimeout(() => {
      for(let i in target){
        target[i].classList.remove('anim'); 
      }
    }, 500);

    let target02 = document.querySelectorAll('.footer-rinner-nav__item.cart');;
    setTimeout(() => {
      for(let i in target02){
        target02[i].classList.add('anim'); 
      }
    }, 0);
    setTimeout(() => {
      for(let i in target02){
        target02[i].classList.remove('anim'); 
      }
    }, 500);

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    var scrollPosition = document.querySelector("cart-drawer-items").scrollTop;
    console.log(scrollPosition);
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-icon-bubble02'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble02',
        section: 'cart-icon-bubble02',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
